import RegisterComponentsContext from '../../components/register-components-context.mjs';
import ReviewModalRoot from '../../components/components/reviews/ReviewModalRoot.jsx';

RegisterComponentsContext([ReviewModalRoot]);